export default "__VITE_ASSET__SA7mMvw___"